/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {AnyData, Link} from '../api/';
import {ApiService} from '../api/api.service';
import {isPresent} from '../utils/lang';

@Pipe({name: 'gpEmployeePhotoUri', pure: false})
export class EmployeePhotoUriPipe implements PipeTransform {

  constructor(private apiService: ApiService) {

  }

  public transform(data: AnyData): any {
    if (!isPresent(data) || !isPresent(data.links)) {
      return;
    }

    const link = data.links.find((item: Link) => item.rel === 'photo');
    if (link) {
      return this.apiService.apiHost + link.href;
    }
  }
}
